import * as actionTypes from "./../../Constants/categoryActionTypes";

const initialState = {
    state: false,
    component: "",
    size: "small",
    submitBtn: "Submit",
    denyBtn: "Cancel"
}

function doShowModal (showModal = initialState ) {
    return{
        type: actionTypes.SHOW_MODAL,
        payload: { showModal }
    }
}

export function showModal(shouldShowModal) {
    //console.log("SHOW MODAL ACTION")
    return dispatch => {
        return dispatch(doShowModal(shouldShowModal));
    };
}